import React from 'react';
import { Box, Alert } from '@mui/material';
import GreetingCard from './GreetingCard';
import NeedsYourAction from './NeedsYourAction';
import ModuleSummaryCards from './ModuleSummaryCards';
import TrendPanelsRow from './TrendPanelsRow';
import OpenItemsMap from './OpenItemsMap';
import TopMembers from './Topmembers';
import useDashboardData from './useDashboardData';

const Dashboard = () => {
  const {
    userFullName,
    currentTime,
    violationsByYearChart,
    maintenanceByMonth,
    architecturalRequestsByYearChart,
    error,
  } = useDashboardData();

  return (
    <Box sx={{ padding: 3 }}>
      {error && <Alert severity="error" sx={{ mb: 2, borderRadius: "12px" }}>{error}</Alert>}
      <GreetingCard userFullName={userFullName} currentTime={currentTime} />
      <NeedsYourAction />
      <ModuleSummaryCards />
      <TrendPanelsRow
        maintenanceByMonth={maintenanceByMonth}
        violationsByYearChart={violationsByYearChart}
        architecturalRequestsByYearChart={architecturalRequestsByYearChart}
      />
      <OpenItemsMap />

      <Box sx={{ marginTop: 5 }}>
        <TopMembers />
      </Box>
    </Box>
  );
};

export default Dashboard;
